module.exports = "/_next/static/images/yogoro_menu_top-7d58f755251b403f21bcb6429c00710f.jpg";